export default {
    navigationBarTitleText: '线下客户列表'
};
